import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-server-line',
    title: 'システム開発',
    subtitle: 'System Development',
    description:
      '業務効率化・DX推進に向けた各種システム・ソフトウェアの企画・設計・開発・配信まで一貫してサポートします。',
    features: ['要件定義・設計', 'バックエンド開発', 'クラウド構築', '保守・運用'],
    color: 'from-teal-400 to-teal-600',
    bg: 'bg-teal-50',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'アプリ開発',
    subtitle: 'App Development',
    description:
      'iOS・Android対応のネイティブアプリからクロスプラットフォームアプリまで、ユーザー体験を重視した開発を行います。',
    features: ['iOS / Android対応', 'UI/UXデザイン', 'API連携', 'ストア申請サポート'],
    color: 'from-cyan-400 to-cyan-600',
    bg: 'bg-cyan-50',
  },
  {
    icon: 'ri-global-line',
    title: 'Webサービス運営',
    subtitle: 'Web Service',
    description:
      'Webサービスの企画・開発から運営・グロースハックまで。インターネット広告・広告代理業も対応しています。',
    features: ['Webサービス開発', 'インターネット広告', '広告代理業', 'SEO・マーケティング'],
    color: 'from-emerald-400 to-teal-500',
    bg: 'bg-emerald-50',
  },
];

export default function ServicesOverview() {
  return (
    <section className="py-16 md:py-24 bg-gray-50/50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-teal-500 text-xs font-semibold uppercase tracking-widest mb-2">Our Services</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            サービス一覧
          </h2>
          <p className="text-gray-500 text-sm max-w-xl mx-auto">
            システム開発からアプリ開発、Webサービス運営まで。<br className="hidden md:block" />
            お客様のビジネス課題に合わせた最適なソリューションを提供します。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className={`${service.bg} rounded-2xl p-6 border border-white hover:border-teal-200 transition-all group`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br ${service.color} mb-4`}>
                <i className={`${service.icon} text-white text-xl`}></i>
              </div>
              <p className="text-teal-500 text-xs font-medium mb-1">{service.subtitle}</p>
              <h3 className="text-lg font-bold text-gray-900 mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {service.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{service.description}</p>
              <ul className="space-y-1.5">
                {service.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-xs text-gray-600">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-check-line text-teal-500 text-xs"></i>
                    </div>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-teal-400 text-teal-600 text-sm font-semibold cursor-pointer hover:bg-teal-50 transition-colors whitespace-nowrap"
          >
            サービス詳細を見る
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
